var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M411.44,108.87c-17-17.62-36.48-32.26-57.18-42.52-31.53-15.63-66.26-23.16-101-23.61C151.76,41.44,144,167.8,112.83,185.37S25.05,205,23.1,275.28c-1.23,44.21,8.51,89.66,35.89,124.1,25.08,31.54,61.93,47.53,98.22,59.34C198,472,241.21,485,284.08,476.05c44-9.19,74.92-46.11,111.05-71.06,22.75-15.71,43.17-32.25,57.22-57.46,1.68-3,3.25-6.08,4.75-9.2,18.81-39.17,22.49-84.35,12.12-126.74C459.92,173.56,438.91,137.33,411.44,108.87Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.44,108.87c-17-17.62-36.48-32.26-57.18-42.52-31.53-15.63-66.26-23.16-101-23.61C151.76,41.44,144,167.8,112.83,185.37S25.05,205,23.1,275.28c-1.23,44.21,8.51,89.66,35.89,124.1,25.08,31.54,61.93,47.53,98.22,59.34C198,472,241.21,485,284.08,476.05c44-9.19,74.92-46.11,111.05-71.06,22.75-15.71,43.17-32.25,57.22-57.46,1.68-3,3.25-6.08,4.75-9.2,18.81-39.17,22.49-84.35,12.12-126.74C459.92,173.56,438.91,137.33,411.44,108.87Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.36,317.53c1.77,1.23,6.54,2.07,6.55,2.07s-.4-3.31-.46-3.52c-.6-2.38-3.18-6.64-5.94-6.81a3.26,3.26,0,0,0-3.37,3.5C285.22,314.71,286.85,316.47,288.36,317.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.25,331.61c2,.7,6.44.32,6.8.28a58.66,58.66,0,0,0,1.15,7.63c.32,1.47.68,2.93,1.06,4.4-.27-.64-.52-1.22-.57-1.29-1.21-2.15-4.82-5.57-7.53-5a3.26,3.26,0,0,0-2.32,4.27c.58,1.85,2.62,3.12,4.35,3.74s5.59.37,6.61.29c.15.57.29,1.13.45,1.69.74,2.69,1.49,5.37,2.14,8,.24.93.43,1.86.63,2.79-.25-.57-.46-1.05-.5-1.12-1.21-2.14-4.82-5.57-7.53-5a3.27,3.27,0,0,0-2.32,4.27c.58,1.86,2.62,3.12,4.36,3.74s5.21.4,6.42.31c.17,1,.34,1.91.47,2.85.07.64.18,1.25.22,1.9s.09,1.27.14,1.9c.05,1.21.1,2.46.12,3.64,0,.83,0,1.61,0,2.4-.22-.93-.69-2.75-.74-2.9-.88-2.3-3.93-6.23-6.69-6.09a3.26,3.26,0,0,0-2.94,3.87c.29,1.92,2.12,3.49,3.74,4.36,1.78,1,6.1,1.27,6.63,1.3,0,1.31,0,2.58,0,3.78-.05,2.44-.15,4.63-.27,6.52l1.77.35c.08-2,.14-4.27.14-6.85,0-1.33,0-2.75,0-4.2a37.16,37.16,0,0,0,4-1c1.09,1.77,4.29,4.24,4.7,4.55-.72,1.09-1.43,2.15-2.11,3.13-1.31,1.88-2.52,3.54-3.61,5l1.9.38c.94-1.32,2-2.81,3.06-4.45.73-1.11,1.5-2.3,2.27-3.54.49.21,4.49,1.89,6.51,1.84,1.84,0,4.18-.62,5.31-2.2a3.27,3.27,0,0,0-.88-4.78c-2.4-1.38-6.89.76-8.72,2.42-.1.09-1.15,1.28-1.8,2.05l.94-1.52c.63-1,1.23-2.09,1.88-3.22l.89-1.68c.31-.56.57-1.18.86-1.78.64-1.39,1.22-2.84,1.78-4.31.9.55,4.15,2.47,6,2.7s4.21,0,5.57-1.37a3.26,3.26,0,0,0-.15-4.86c-2.15-1.72-6.92-.29-9,1.07-.13.08-1.5,1.23-2.23,1.87.32-.89.65-1.77.95-2.67.87-2.62,1.67-5.3,2.48-8,.24-.82.5-1.63.75-2.44.32.2,4.14,2.55,6.19,2.81,1.83.24,4.22,0,5.58-1.37a3.26,3.26,0,0,0-.15-4.85c-2.16-1.73-6.93-.3-9,1.06-.15.11-2.11,1.75-2.59,2.2.56-1.79,1.13-3.57,1.76-5.3a59.58,59.58,0,0,1,3-6.84c.15.1,4.12,2.57,6.22,2.84,1.83.24,4.22,0,5.58-1.37a3.27,3.27,0,0,0-.15-4.86c-2.16-1.72-6.93-.29-9,1.07-.16.11-2.27,1.88-2.63,2.23.07-.12.13-.26.2-.39a41.45,41.45,0,0,1,4.18-6.2c.85-1.08,1.73-2.07,2.61-3,.69.54,3.88,3,5.74,3.41s4.19.48,5.7-.75a3.26,3.26,0,0,0,.38-4.84c-1.95-1.95-6.85-1.06-9,.07-.12.06-1.26.82-2.08,1.39.4-.42.81-.86,1.2-1.25,1.47-1.48,2.91-2.75,4.19-3.86.74-.62,1.42-1.17,2.06-1.68.95.17,4.8.82,6.63.37s3.94-1.5,4.71-3.29a3.27,3.27,0,0,0-1.89-4.48c-2.63-.82-6.57,2.22-8,4.24-.12.17-1.73,3.11-1.68,3.12h.05c-.62.48-1.29,1-2,1.58-1.31,1.08-2.78,2.31-4.29,3.77a57.18,57.18,0,0,0-4.65,4.92,42,42,0,0,0-4.37,6.18.59.59,0,0,1,0,.08c.17-.79.58-3,.59-3.19.17-2.46-.95-7.31-3.52-8.33a3.26,3.26,0,0,0-4.29,2.28c-.54,1.87.46,4.05,1.57,5.52,1.25,1.66,5.2,3.82,5.51,4a56.57,56.57,0,0,0-3.24,7c-.55,1.4-1.06,2.82-1.55,4.26.13-.69.24-1.31.24-1.4.17-2.45-.95-7.3-3.52-8.33a3.26,3.26,0,0,0-4.29,2.28c-.54,1.87.46,4.05,1.57,5.52s4.46,3.4,5.34,3.89c-.18.55-.37,1.1-.55,1.66-.86,2.65-1.72,5.3-2.63,7.87-.33.91-.68,1.79-1,2.67.11-.61.2-1.13.2-1.21.17-2.45-.95-7.3-3.51-8.33a3.28,3.28,0,0,0-4.3,2.28c-.53,1.87.47,4.05,1.57,5.52s4.13,3.21,5.19,3.8c-.39.9-.77,1.79-1.18,2.64-.3.57-.54,1.15-.87,1.71l-.93,1.66c-.63,1-1.27,2.11-1.91,3.11l-1.3,2c.33-.9.94-2.68,1-2.83a12.75,12.75,0,0,0-.47-6.38,3.57,3.57,0,0,0,.1-.72,3.27,3.27,0,0,0-3.37-3.5c-2.76.18-5.33,4.44-5.94,6.83,0,.14-.25,1.71-.37,2.7,0-.59,0-1.17-.05-1.78-.05-1.21-.13-2.42-.21-3.72l-.18-1.9c-.05-.63-.18-1.3-.27-1.95-.23-1.52-.55-3.05-.89-4.58,1.06,0,4.82-.24,6.48-1s3.53-2.31,3.9-4.22a3.26,3.26,0,0,0-2.81-4c-2.75-.25-5.94,3.57-6.9,5.84-.06.14-.56,1.85-.82,2.79-.22-.92-.43-1.84-.68-2.76-.72-2.66-1.53-5.33-2.33-8l-.72-2.45c.38,0,4.86-.15,6.72-1.07,1.65-.81,3.53-2.3,3.9-4.22a3.27,3.27,0,0,0-2.81-4c-2.75-.24-5.94,3.58-6.9,5.85-.07.17-.8,2.63-.95,3.26-.52-1.8-1-3.6-1.45-5.39a57.5,57.5,0,0,1-1.28-7.35c.18,0,4.85-.13,6.76-1.07,1.65-.81,3.52-2.31,3.89-4.22a3.27,3.27,0,0,0-2.8-4c-2.75-.24-5.94,3.58-6.9,5.85-.08.18-.86,2.82-1,3.31,0-.15-.05-.29-.06-.44a41.22,41.22,0,0,1,.07-7.47c.11-1.38.3-2.68.51-3.95.88.06,4.87.32,6.68-.33s3.76-1.91,4.33-3.77a3.26,3.26,0,0,0-2.35-4.25c-2.7-.55-6.29,2.9-7.5,5.05-.06.12-.6,1.38-1,2.3.1-.57.2-1.16.31-1.7.41-2,.92-3.9,1.37-5.53.27-.93.53-1.76.79-2.53.89-.39,4.46-2,5.74-3.36s2.46-3.42,2.11-5.34a3.27,3.27,0,0,0-4-2.69c-2.65.76-4.25,5.48-4.33,7.94,0,.21.27,3.55.32,3.53l.05,0c-.25.74-.52,1.54-.8,2.42-.49,1.63-1,3.47-1.5,5.51a59.83,59.83,0,0,0-1.16,6.67,42.86,42.86,0,0,0-.23,7.57s0,.06,0,.09c-.29-.75-1.18-2.84-1.27-3-1.22-2.14-4.83-5.57-7.53-5a3.27,3.27,0,0,0-2.32,4.27C283.48,329.73,285.52,331,287.25,331.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.2,328.16s1.49-3,1.56-3.19c.81-2.33,1-7.3-1.19-9a3.26,3.26,0,0,0-4.74,1.06c-1,1.66-.63,4,.05,5.74C332.68,324.82,336.2,328.15,336.2,328.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.75,129.52c1.89.27,6-1,6-1s-1.63-2.46-1.75-2.6c-1.43-1.64-5.15-4-7.39-3a2.89,2.89,0,0,0-1.27,4.1C182.16,128.54,184.15,129.28,185.75,129.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.47,141.06c1.81-.23,5.2-2.31,5.47-2.47a49.66,49.66,0,0,0,3.93,5.55c.83,1,1.69,2.05,2.57,3.05-.47-.4-.89-.75-1-.79-1.8-1.21-6-2.48-7.92-1a2.89,2.89,0,0,0-.14,4.29c1.2,1.23,3.31,1.42,4.92,1.22s4.56-1.92,5.32-2.38c.34.38.68.77,1,1.15,1.65,1.82,3.3,3.64,4.87,5.47.55.65,1.07,1.3,1.59,2-.42-.36-.77-.65-.83-.69-1.81-1.21-6-2.48-7.92-1a2.88,2.88,0,0,0-.14,4.29c1.19,1.23,3.3,1.42,4.92,1.22s4.27-1.75,5.18-2.3c.51.69,1,1.37,1.5,2.06.31.48.64.92.93,1.41l.86,1.44c.52.94,1.06,1.9,1.54,2.83.34.64.65,1.26,1,1.88-.55-.65-1.63-1.89-1.74-2-1.6-1.47-5.56-3.36-7.68-2.15a2.88,2.88,0,0,0-.79,4.21c1,1.4,3.05,1.91,4.68,2,1.78,0,5.31-1.42,5.75-1.6.51,1,1,2,1.46,3,.93,1.94,1.71,3.71,2.37,5.25l1.53-.43c-.72-1.58-1.58-3.42-2.6-5.45-.52-1-1.1-2.16-1.71-3.29a32.78,32.78,0,0,0,2.79-2.4,20.92,20.92,0,0,0,5.52,1.73c-.14,1.15-.28,2.26-.43,3.31-.29,2-.59,3.79-.87,5.36l1.65-.46c.22-1.41.44-3,.65-4.71.14-1.17.27-2.41.39-3.69.46,0,4.28-.29,5.86-1.14,1.43-.77,3-2.14,3.31-3.84a2.87,2.87,0,0,0-2.59-3.41c-2.43-.14-5.13,3.33-5.91,5.35-.05.12-.4,1.48-.61,2.34,0-.53.1-1,.14-1.57.08-1.07.14-2.13.21-3.28l0-1.68c0-.56,0-1.16,0-1.74,0-1.36-.16-2.73-.3-4.11.93.08,4.25.3,5.79-.24s3.33-1.66,3.85-3.3a2.88,2.88,0,0,0-2-3.77c-2.39-.5-5.58,2.52-6.66,4.4-.06.12-.69,1.56-1,2.36-.1-.82-.19-1.65-.31-2.48-.35-2.41-.78-4.84-1.2-7.26-.13-.74-.25-1.48-.37-2.22.33,0,4.27.37,6-.23,1.53-.54,3.33-1.66,3.86-3.3a2.88,2.88,0,0,0-2-3.77c-2.38-.5-5.57,2.52-6.65,4.4-.08.15-1,2.22-1.18,2.76-.27-1.63-.52-3.26-.7-4.87a50.9,50.9,0,0,1-.36-6.58c.16,0,4.27.4,6-.23,1.53-.54,3.33-1.65,3.86-3.29a2.88,2.88,0,0,0-2.05-3.77c-2.38-.5-5.58,2.51-6.65,4.4-.09.15-1,2.39-1.19,2.8,0-.12,0-.26,0-.38a38.54,38.54,0,0,1,.84-6.55c.25-1.19.55-2.31.87-3.4.76.15,4.23.79,5.88.4s3.49-1.27,4.19-2.84a2.89,2.89,0,0,0-1.61-4c-2.32-.76-5.82,1.89-7.1,3.65-.07.09-.67,1.14-1.1,1.92.15-.49.3-1,.45-1.47.58-1.75,1.21-3.31,1.79-4.7.33-.78.64-1.48.95-2.14.82-.24,4.11-1.25,5.37-2.34s2.52-2.74,2.41-4.46a2.88,2.88,0,0,0-3.26-2.78c-2.41.4-4.3,4.36-4.62,6.51,0,.19-.14,3.14-.09,3.13l.05,0c-.31.63-.63,1.3-1,2-.6,1.37-1.27,2.93-1.89,4.68a49.86,49.86,0,0,0-1.71,5.72,37.81,37.81,0,0,0-1,6.6v.08c-.18-.69-.74-2.6-.8-2.75-.84-2-3.64-5.38-6.07-5.17a2.87,2.87,0,0,0-2.48,3.5c.32,1.69,2,3,3.42,3.73,1.65.81,5.62,1,5.93,1a52.13,52.13,0,0,0,.21,6.81c.13,1.32.29,2.64.47,4-.17-.59-.33-1.12-.36-1.19-.84-2-3.65-5.38-6.07-5.17a2.88,2.88,0,0,0-2.49,3.49c.32,1.69,2,3,3.43,3.74s4.86.91,5.75.95c.08.5.15,1,.22,1.52.37,2.43.75,4.86,1.05,7.25.1.84.17,1.68.25,2.51-.15-.53-.29-1-.32-1-.84-2-3.64-5.39-6.07-5.18a2.88,2.88,0,0,0-2.48,3.5c.32,1.69,2,3,3.42,3.73s4.53.9,5.6.94c.05.86.1,1.72.11,2.55,0,.57,0,1.12,0,1.69s-.05,1.12-.08,1.68c-.08,1.06-.16,2.16-.27,3.2-.07.73-.15,1.41-.23,2.11-.1-.84-.32-2.48-.35-2.62a11.2,11.2,0,0,0-2.89-4.85,3.86,3.86,0,0,0-.21-.6,2.88,2.88,0,0,0-4.05-1.42c-2.1,1.23-2.44,5.6-2,7.73,0,.12.48,1.45.78,2.28-.25-.46-.49-.91-.76-1.39-.51-.93-1.05-1.85-1.63-2.85l-.9-1.42c-.29-.48-.65-.95-1-1.44-.79-1.1-1.64-2.18-2.52-3.25.82-.45,3.71-2.1,4.69-3.4s1.87-3.22,1.4-4.87a2.88,2.88,0,0,0-3.78-2c-2.27.9-3.27,5.17-3.13,7.34,0,.14.29,1.68.46,2.53-.54-.64-1.07-1.28-1.63-1.91-1.62-1.81-3.32-3.59-5-5.38l-1.53-1.65c.29-.16,3.77-2,4.87-3.5,1-1.3,1.87-3.22,1.4-4.87a2.88,2.88,0,0,0-3.79-2c-2.26.89-3.26,5.17-3.12,7.34,0,.16.41,2.39.54,2.95-1.12-1.21-2.23-2.43-3.28-3.68a51.92,51.92,0,0,1-3.92-5.29c.14-.07,3.78-2,4.9-3.51,1-1.3,1.87-3.22,1.4-4.87a2.88,2.88,0,0,0-3.78-2c-2.26.89-3.27,5.17-3.12,7.34,0,.17.44,2.56.55,3l-.22-.32a37.22,37.22,0,0,1-2.91-5.92c-.45-1.13-.82-2.23-1.15-3.32.71-.29,4-1.67,5.13-2.9s2.21-3,1.92-4.69a2.88,2.88,0,0,0-3.54-2.42c-2.35.64-3.81,4.78-3.91,7,0,.12.08,1.33.15,2.21-.15-.49-.3-1-.43-1.47-.49-1.78-.82-3.43-1.11-4.9-.16-.84-.28-1.6-.39-2.31.55-.66,2.74-3.32,3.2-4.92s.58-3.68-.45-5a2.88,2.88,0,0,0-4.26-.52c-1.79,1.65-1.18,6-.27,8,.08.17,1.63,2.69,1.65,2.66l0,0c.09.69.19,1.42.33,2.22.25,1.48.55,3.15,1,4.94a51.12,51.12,0,0,0,1.72,5.72,37.39,37.39,0,0,0,2.82,6.06.43.43,0,0,1,0,.07c-.53-.48-2-1.77-2.18-1.85-1.81-1.21-6-2.48-7.92-1a2.88,2.88,0,0,0-.14,4.29C186.75,141.07,188.85,141.26,190.47,141.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.68,118.94s0-3,0-3.14c-.28-2.15-2.09-6.15-4.49-6.59a2.89,2.89,0,0,0-3.32,2.72c-.14,1.71,1.11,3.42,2.32,4.5C223.59,117.7,227.68,118.94,227.68,118.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.54,413.62c1.78-.58,4.85-3.44,4.85-3.44s-2.5-1.45-2.67-1.52c-2-.83-6.25-1.27-7.81.54a2.84,2.84,0,0,0,.66,4.16C55,414.32,57,414.11,58.54,413.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,421.74c1.5-1,3.58-4.29,3.74-4.56a49.13,49.13,0,0,0,5.87,3.19c1.18.55,2.38,1.06,3.59,1.57l-1.19-.29c-2.11-.28-6.36.43-7.39,2.59a2.84,2.84,0,0,0,1.74,3.84c1.59.56,3.53-.19,4.86-1.06s3.18-3.67,3.65-4.41l1.4.56c2.24.9,4.49,1.78,6.66,2.71.77.33,1.51.68,2.26,1l-1-.25c-2.11-.28-6.36.43-7.39,2.59a2.84,2.84,0,0,0,1.74,3.84c1.59.56,3.53-.19,4.86-1.06s3-3.4,3.56-4.28c.75.38,1.51.76,2.22,1.16.48.29,1,.53,1.43.84l1.38.9c.87.6,1.76,1.21,2.58,1.82.58.41,1.12.82,1.67,1.23-.76-.33-2.26-1-2.39-1-2.05-.59-6.36-.54-7.7,1.44A2.84,2.84,0,0,0,95,438.2c1.48.8,3.51.35,5-.31,1.6-.74,4.06-3.56,4.37-3.91.9.68,1.78,1.35,2.59,2,1.66,1.31,3.11,2.52,4.36,3.59l1.16-1c-1.31-1.08-2.88-2.32-4.65-3.67-.92-.7-1.91-1.42-2.94-2.16a27.58,27.58,0,0,0,1.42-3.32,20.21,20.21,0,0,0,5.6-.87c.38,1.07.74,2.11,1.06,3.1.62,1.88,1.14,3.59,1.57,5.09l1.25-1.11c-.42-1.34-.91-2.83-1.48-4.43-.38-1.09-.8-2.24-1.25-3.42.39-.23,3.64-2.12,4.66-3.55s1.75-3.2,1.25-4.81a2.82,2.82,0,0,0-3.76-1.88c-2.2.93-3.08,5.15-2.88,7.28,0,.12.29,1.47.48,2.32l-.56-1.44c-.39-1-.8-1.94-1.24-3-.23-.5-.47-1-.7-1.5s-.52-1-.78-1.52c-.63-1.17-1.33-2.33-2-3.47.85-.34,3.87-1.59,5-2.74s2.21-2.9,2-4.57a2.83,2.83,0,0,0-3.44-2.43c-2.31.59-3.81,4.63-3.94,6.76,0,.14.07,1.68.13,2.52-.44-.69-.88-1.38-1.35-2.06-1.36-2-2.79-3.91-4.21-5.86-.44-.6-.86-1.2-1.29-1.8.3-.11,3.92-1.52,5.17-2.8s2.22-2.9,2-4.57a2.83,2.83,0,0,0-3.44-2.43c-2.31.59-3.82,4.63-4,6.76,0,.16.11,2.37.17,2.94-1-1.32-1.88-2.65-2.74-4a48.71,48.71,0,0,1-3.17-5.63c.14-.06,3.93-1.51,5.21-2.82,1.11-1.14,2.22-2.9,2-4.57A2.82,2.82,0,0,0,98,386.47c-2.32.59-3.82,4.63-3.95,6.76,0,.17.12,2.55.17,3,0-.11-.12-.22-.17-.34a35.79,35.79,0,0,1-2.1-6.12c-.3-1.16-.53-2.28-.72-3.37.73-.2,4.07-1.14,5.36-2.2s2.52-2.64,2.45-4.33a2.83,2.83,0,0,0-3.15-2.79c-2.36.33-4.3,4.19-4.66,6.29,0,.11-.1,1.3-.14,2.16-.07-.49-.17-1-.23-1.48-.26-1.79-.38-3.45-.47-4.91,0-.84-.08-1.59-.1-2.3.62-.57,3.08-2.89,3.72-4.39s1-3.51.18-5a2.82,2.82,0,0,0-4.08-1c-1.94,1.39-1.89,5.7-1.24,7.73.06.17,1.25,2.82,1.28,2.79l0,0c0,.68,0,1.41,0,2.21.06,1.47.15,3.13.37,4.93a50.15,50.15,0,0,0,1,5.78,37.89,37.89,0,0,0,2,6.25.43.43,0,0,1,0,.07c-.46-.53-1.78-2-1.9-2.08-1.61-1.39-5.55-3.15-7.59-1.91a2.83,2.83,0,0,0-.67,4.15c1,1.35,3,1.8,4.64,1.8,1.8,0,5.35-1.6,5.63-1.73a49.26,49.26,0,0,0,3.14,5.89c.68,1.11,1.4,2.2,2.13,3.29-.41-.44-.77-.84-.83-.89-1.61-1.4-5.55-3.15-7.59-1.92a2.82,2.82,0,0,0-.67,4.16c1,1.35,3,1.79,4.63,1.8s4.68-1.31,5.48-1.67l.86,1.25c1.38,2,2.76,3.95,4.06,5.93.46.69.89,1.4,1.31,2.1-.36-.4-.67-.73-.72-.77-1.61-1.4-5.55-3.16-7.59-1.92a2.81,2.81,0,0,0-.67,4.15c1,1.35,3,1.8,4.64,1.8s4.37-1.18,5.33-1.6c.41.73.83,1.46,1.2,2.19.25.5.52,1,.73,1.49s.45,1,.67,1.51c.38,1,.79,2,1.14,2.94.26.67.48,1.31.71,1.95-.44-.69-1.35-2-1.44-2.15a10.93,10.93,0,0,0-4.65-3,2.68,2.68,0,0,0-.45-.44A2.81,2.81,0,0,0,101,423c-1.32,2,.28,6,1.61,7.66.08.09,1.06,1.07,1.68,1.67l-1.26-.9c-.86-.6-1.74-1.17-2.68-1.8l-1.4-.86c-.47-.3-1-.55-1.5-.84-1.17-.63-2.38-1.21-3.62-1.76.52-.76,2.35-3.46,2.65-5s.25-3.64-.88-4.89a2.83,2.83,0,0,0-4.21-.13c-1.6,1.77-.63,6,.44,7.81.06.12,1,1.36,1.5,2-.75-.33-1.5-.66-2.26-1-2.22-.89-4.49-1.73-6.75-2.57l-2.07-.78c.19-.27,2.43-3.44,2.77-5.2.3-1.57.25-3.64-.88-4.9a2.84,2.84,0,0,0-4.21-.13c-1.6,1.77-.63,6,.44,7.82.08.14,1.4,1.92,1.76,2.36-1.52-.58-3-1.17-4.49-1.81a52.44,52.44,0,0,1-5.74-2.95c.08-.13,2.44-3.42,2.78-5.23.3-1.56.25-3.64-.88-4.89a2.83,2.83,0,0,0-4.21-.14c-1.6,1.78-.62,6,.44,7.82.09.15,1.51,2.06,1.79,2.39l-.33-.18a36,36,0,0,1-5.13-3.95c-.89-.8-1.7-1.61-2.46-2.42.5-.57,2.76-3.19,3.25-4.78s.65-3.6-.34-5a2.82,2.82,0,0,0-4.16-.59c-1.79,1.58-1.28,5.86-.43,7.82,0,.1.64,1.13,1.09,1.88-.34-.38-.7-.75-1-1.11-1.2-1.35-2.21-2.67-3.1-3.84-.5-.66-.94-1.28-1.34-1.86.2-.81,1-4.11.67-5.72s-1.08-3.48-2.59-4.24a2.82,2.82,0,0,0-4,1.39c-.86,2.23,1.57,5.79,3.23,7.13.14.12,2.6,1.67,2.61,1.63v-.05c.38.56.79,1.17,1.25,1.82.87,1.19,1.86,2.52,3,3.91a50.07,50.07,0,0,0,4,4.28A36.58,36.58,0,0,0,71.15,417l.07,0c-.67-.19-2.58-.66-2.73-.68-2.11-.28-6.36.43-7.39,2.59a2.84,2.84,0,0,0,1.74,3.84C64.43,423.36,66.37,422.61,67.7,421.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,386.11c.05,0-1.28-2.59-1.38-2.75-1.19-1.77-4.52-4.5-6.82-3.85a2.82,2.82,0,0,0-1.74,3.83c.62,1.57,2.46,2.54,4,3C86.71,386.8,90.85,386.11,90.85,386.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shine--inject-14"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 229.99,
    y1: 136.76,
    x2: 221.04,
    y2: 144.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.64,
    y1: 66.74,
    x2: 257.57,
    y2: 112.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.85,
    y1: 64.79,
    x2: 251.22,
    y2: 83.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255.48,
    y1: 57.22,
    x2: 222.98,
    y2: 59.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.08,
    y1: 54.08,
    x2: 259.11,
    y2: 56.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278.68,
    y1: 33.9,
    x2: 244.82,
    y2: 22.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 290.16,
    y1: 37.53,
    x2: 283.39,
    y2: 35.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 426.28,
    y1: 136.76,
    x2: 435.23,
    y2: 144.63,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 346.63,
    y1: 66.74,
    x2: 420.77,
    y2: 131.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 354.42,
    y1: 64.79,
    x2: 405.05,
    y2: 83.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.78,
    y1: 57.22,
    x2: 433.28,
    y2: 59.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.18,
    y1: 54.08,
    x2: 397.16,
    y2: 56.91,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.59,
    y1: 33.9,
    x2: 403.46,
    y2: 25.7,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.1,
    y1: 37.53,
    x2: 372.88,
    y2: 35.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trophy--inject-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.75,
    y: 58.31,
    width: 5.36,
    height: 22.82,
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.35 86.02 318.51 86.02 320.38 77.17 332.48 77.17 334.35 86.02",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.89 89.74 308.97 89.74 312.69 81.59 340.17 81.59 343.89 89.74",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.73,34.15a12.58,12.58,0,1,0,12.34,12.58A12.46,12.46,0,0,0,308.73,34.15Zm0,22a9.38,9.38,0,1,1,9.21-9.37A9.29,9.29,0,0,1,308.73,56.1Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,34.15a12.58,12.58,0,1,0,12.34,12.58A12.46,12.46,0,0,0,346,34.15Zm0,22a9.38,9.38,0,1,1,9.2-9.37A9.29,9.29,0,0,1,346,56.1Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.43,64.59h0A15.59,15.59,0,0,1,310.83,49V32.93H342V49A15.59,15.59,0,0,1,326.43,64.59Z",
    style: {
      fill: "#D175F7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326 38.06 328.01 44.24 334.51 44.24 329.25 48.06 331.26 54.24 326 50.42 320.74 54.24 322.75 48.06 317.49 44.24 323.99 44.24 326 38.06",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Factors--inject-14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.56,
    y: 89.82,
    width: 102.4,
    height: 93.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.56,
    y: 89.82,
    width: 68.06,
    height: 93.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.73,
    y: 136.2,
    width: 102.4,
    height: 93.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.73,
    y: 136.2,
    width: 68.06,
    height: 93.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,162.65v-7.46h-4.67a14.92,14.92,0,0,0-1.58-3.71l2.89-2.9-5.28-5.28-2.88,2.88a15,15,0,0,0-4.16-1.73V141h-7.47v3.45a15.22,15.22,0,0,0-4.54,2l-2.06-2.06L208,149.64l2.23,2.23a15,15,0,0,0-1.69,4.81h-2.84v7.47h3.4a15.34,15.34,0,0,0,2.25,4.3l-2.3,2.3L214.3,176l2.85-2.85a15.25,15.25,0,0,0,4.2,1.26v3.89h7.46v-4.65a15.27,15.27,0,0,0,3.5-1.81l3.11,3.11,5.28-5.28-3.47-3.47a15.13,15.13,0,0,0,1.29-3.58Zm-19.41,6a9.34,9.34,0,1,1,9.33-9.34A9.34,9.34,0,0,1,223.59,168.63Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.83,192.25v-5.49H246.4a11.42,11.42,0,0,0-1.17-2.73l2.13-2.13L243.48,178l-2.12,2.12a11,11,0,0,0-3.06-1.27v-2.54h-5.49v2.54a11.07,11.07,0,0,0-3.34,1.45L228,178.8l-3.88,3.88,1.64,1.64a11.31,11.31,0,0,0-1.25,3.54h-2.08v5.49h2.5a11.21,11.21,0,0,0,1.65,3.16l-1.69,1.69,3.88,3.88,2.1-2.09a11.44,11.44,0,0,0,3.08.92v2.86h5.49v-3.41A11.41,11.41,0,0,0,242,199l2.29,2.29,3.88-3.88-2.55-2.55a11,11,0,0,0,.94-2.63Zm-14.27,4.39a6.86,6.86,0,1,1,6.86-6.86A6.86,6.86,0,0,1,235.56,196.64Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.35,
    y: 196.44,
    width: 102.4,
    height: 93.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.35,
    y: 196.44,
    width: 68.06,
    height: 93.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,212.7l-5.91-4.36a6.84,6.84,0,0,0-7.77-.25l-11.72,7a2.9,2.9,0,0,0,2.58,5.17l10.95-3.76L306,230.1l8.17-2.85V210.62Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.41,218.34,280.5,222.1c-2,.86-4.17-2.46-4.17-4.62h0c0-2.79,2.66-3.56,4.75-5.41l2-1.76a7.28,7.28,0,0,0-8.09-1.16h0a13.63,13.63,0,0,1-10.09.76L262,209v18.48l3.7.46.35-.3a6.16,6.16,0,0,1,8.53.49l13.12,14.11a1.72,1.72,0,0,0,2.34.16h0a1.71,1.71,0,0,0,.19-2.46l-3.28-3.68,4.55,3A2.14,2.14,0,0,0,294.2,236l-2.64-2.74,4,2.53a2.36,2.36,0,0,0,3-3.57l-2.37-2.65,4.34,2.63a1.85,1.85,0,0,0,2.13-.15h0a1.85,1.85,0,0,0,.11-2.77Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,234.63l1.68-2.12a2.19,2.19,0,0,0-3.43-2.72l-1.68,2.12a2.19,2.19,0,0,0,3.43,2.72Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.24,237.72l1.68-2.12a2.19,2.19,0,0,0-3.43-2.71L270.81,235a2.19,2.19,0,0,0,3.43,2.71Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,240.81l1.67-2.11a2.19,2.19,0,0,0-3.43-2.72L274,238.1a2.19,2.19,0,0,0,.35,3.07h0A2.19,2.19,0,0,0,277.45,240.81Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,238.72a2.18,2.18,0,0,0-3.07.36l-1.68,2.11a2.19,2.19,0,1,0,3.43,2.72l1.68-2.12A2.18,2.18,0,0,0,282,238.72Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.2,
    y: 256.07,
    width: 102.4,
    height: 93.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.2,
    y: 256.07,
    width: 68.06,
    height: 93.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.49,
    y: 302.84,
    width: 7.53,
    height: 12.49,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.63,
    y: 297.5,
    width: 7.53,
    height: 17.84,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.78,
    y: 293.85,
    width: 7.53,
    height: 21.48,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.92,
    y: 288.99,
    width: 7.53,
    height: 26.35,
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,281.15l-6.07,1.9,1.61,1.48-4.31,4.7-10.12,1.92-10.64,8.17a1,1,0,0,0-.19,1.4,1,1,0,0,0,1.4.18L187,293l10.3-2,4.76-5.18,1.61,1.48Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.25,
    y: 326.94,
    width: 102.4,
    height: 93.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.25,
    y: 326.94,
    width: 68.06,
    height: 93.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.26,359.89,265,355.76v-1.18a10.51,10.51,0,0,0,2.11-6.1c0-5.41-2.21-6-4.95-6s-4.95,1.18-4.95,6a10.56,10.56,0,0,0,2.2,6.21v.69l-6.86,4.51a4.15,4.15,0,0,0-1.87,3.47v1.48l10.9,4.78,11.58-4.78v-1.48A4.15,4.15,0,0,0,271.26,359.89Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.13,353.8a16.21,16.21,0,1,0-18.58,16v12.79a3.49,3.49,0,0,0-1.5,2.86v21.7a3.5,3.5,0,0,0,7,0v-21.7a3.46,3.46,0,0,0-1.5-2.86V369.93A16.23,16.23,0,0,0,278.13,353.8Zm-29.42,0A13.21,13.21,0,1,1,261.92,367,13.23,13.23,0,0,1,248.71,353.8Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.67,
    y: 394.3,
    width: 102.4,
    height: 93.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.67,
    y: 394.3,
    width: 68.06,
    height: 93.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,451.63a4.17,4.17,0,0,0-1.88-3.48L153.34,444v-1.18a10.52,10.52,0,0,0,2.12-6.1c0-5.4-2.22-6-5-6s-4.95,1.18-4.95,6a10.45,10.45,0,0,0,2.2,6.21v.7l-6.86,4.5a4.17,4.17,0,0,0-1.88,3.48v3.78a8.44,8.44,0,0,0-1.78-.15,6.85,6.85,0,0,0-1.53.15v-3.78a4.17,4.17,0,0,0-1.88-3.48L127.54,444v-1.18a10.52,10.52,0,0,0,2.12-6.1c0-4.15-1.31-5.47-3.17-5.86l3.21-3.66h5.45l1.46,20.91h.65l2.1-20.92h7.4l2.81,3.24-.19-3.24H153V399.87H122.39v27.35h4.46l-.41,3.65a9.55,9.55,0,0,0-1.73-.14c-2.74,0-4.95,1.18-4.95,6A10.45,10.45,0,0,0,122,443v.7l-6.86,4.5a4.17,4.17,0,0,0-1.88,3.48V458h19.57a9.25,9.25,0,0,0-.5,3.29,10.5,10.5,0,0,0,2.2,6.21v.69l-6.86,4.51a4.14,4.14,0,0,0-1.88,3.47v6.35h22.49v-6.35a4.14,4.14,0,0,0-1.88-3.47l-6.29-4.13v-1.18a10.52,10.52,0,0,0,2.12-6.1,11,11,0,0,0-.41-3.29h19.73Zm-38.46-25.07v-26h29.31v26h-3.67l.11,2-1.74-2h-8.3L137,444.23l-1.23-17.67H129.4L127.32,429l.26-2.39Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.24 421.63 140.96 421.63 140.96 420.61 134.25 420.61 134.24 421.63",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.7,423.42h5.8a1.65,1.65,0,0,0,.46-1.14h-6.72A1.65,1.65,0,0,0,134.7,423.42Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,425.6h1.7a1.66,1.66,0,0,0,1.67-1.66h-5A1.65,1.65,0,0,0,136.74,425.6Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.26,415.51a6.65,6.65,0,0,1,1.53,4.25v.31h5.64v-.31a6.62,6.62,0,0,1,1.54-4.25,5.65,5.65,0,0,0,1.33-3.64,5.67,5.67,0,0,0-6.06-5.66,5.68,5.68,0,0,0-4,9.3Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.18,411.91a.54.54,0,0,0,.54.54h2.85a.54.54,0,0,0,0-1.08h-2.85A.54.54,0,0,0,144.18,411.91Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.84,411.91a.54.54,0,0,0-.54-.54h-2.88a.54.54,0,1,0,0,1.08h2.88A.54.54,0,0,0,130.84,411.91Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.51,405.23h0a.54.54,0,0,0,.54-.54v-2.86a.53.53,0,0,0-.53-.54h0a.54.54,0,0,0-.53.54v2.85A.55.55,0,0,0,137.51,405.23Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.66,407.29a.55.55,0,0,0,.38-.16l2-2a.53.53,0,0,0,0-.76.55.55,0,0,0-.77,0l-2,2a.54.54,0,0,0,0,.76A.59.59,0,0,0,142.66,407.29Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,416.66l-2,2a.54.54,0,0,0,0,.76.53.53,0,0,0,.76,0l2-2a.54.54,0,0,0-.76-.76Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9,407.07a.54.54,0,0,0,.39.16.54.54,0,0,0,.38-.92l-1.91-1.91a.54.54,0,1,0-.76.76Z",
    style: {
      fill: "#D175F7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.09,416.75a.55.55,0,0,0-.77,0,.54.54,0,0,0,0,.76l1.9,1.9a.53.53,0,0,0,.76,0,.54.54,0,0,0,0-.76Z",
    style: {
      fill: "#D175F7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.24,183.94s3.27,3.75,2.78,5.06a15.07,15.07,0,0,0-.49,3.92s4.24,2.29,4.24,3.43a9.68,9.68,0,0,1-1,3.1s1,6.53.33,8.16-7.68,2.78-7.68,2.78l-2.61,8-15-4.57,2.45-8s-3.75-9.47-4.41-12.57,4.08-9.15,10-10.62A18.4,18.4,0,0,1,178.24,183.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.18,198.8s2.61.16,2.29-1.15-1.31-2-.82-2.61,3.59-2.61,2.61-3.92-3.92-2.28-2.61-3.75,8.82-4.74,8.82-4.74-7.68-3.59-8.82-3.59,4.57-1.79,2.61-3.26-14.53-1.47-19.59,5.22-4.41,10.61-2.45,16.16,5.71,12.09,7.67,12.58,8.49.81,8.82-1.47S173.18,198.8,173.18,198.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,200.27s-4.62-5.71-4.9-3.53,1.36,10,4.35,8.15",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.67,216.92s3.59,1.14,12.24,2.94,16,3.59,16,3.59-2.28-6.86-4.73-8.16-15.51-3.92-17.14-3.76S149.67,216.92,149.67,216.92Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,262.47s14.86-13.38,15.67-14.2-1-7.18-1-8.16,3.43-2.62,3.43-2.62.49-2.61,2.12-2.61,4.41,2.12,4.41,2.12l.33,1.8s2.28,5.06,2.28,5.88a7.82,7.82,0,0,1-2.28,4.57c-1.63,1.63-5.39,5.06-5.39,5.06s-13.06,17.63-16,20.08-6.86,5.06-8.33,2.13S205,262.47,205,262.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "223.14 237.49 223.63 238.8 222.32 239.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.14,243.37s-5.72,5.88-5.39,8.33,13.55,29.71,13.55,29.71,1,4.09,1.63,4.41,2.12,2.78,2.12,2.78,0,2.12,2.45-.17,5.88-4.89,5.72-7a6.77,6.77,0,0,0-1.8-3.75s-.81-2-1.63-2.12-4.57-.17-4.57-.17L119,253.17Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.52,279.29l2.13,1.14s-2.62,3.92-1.64,4.74,3.92-5.06,4.25-5.88-.49-1.63-.49-1.63",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.83,
    y1: 280.76,
    x2: 121.58,
    y2: 284.52,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,363.11l-10.59,9.18a5.25,5.25,0,0,0,2.12,2.59c1.41.71,7.53,6.6,9.41,7.77a22.75,22.75,0,0,0,11.3,3.53c5,0,5.89-1.88,5.89-2.59s-9.65-7.06-9.65-7.06l-2.12-8.47Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.34,370.45l-2.13,1.84a5.25,5.25,0,0,0,2.12,2.59c1.41.71,7.53,6.6,9.41,7.77a22.75,22.75,0,0,0,11.3,3.53c2.9,0,4.41-.64,5.18-1.32a45.22,45.22,0,0,0-6.49-1.06c-3.24,0-6.81-2.91-6.81-2.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,271.45s-2.3,12-.23,15.79a77.83,77.83,0,0,0,5.52,8.28l29.34,37.62L132.3,363.86l7.33,7.49s40-33,42.37-34.41,0-13.12-.69-14.15-14.48-31.2-14.48-31.2l1.29-13.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7,379.43s7.13,7.94,8.27,8.75,9.23,5.51,9.23,5.51-.16,1.13-.81,1.3-16.69.32-17.82.16S139,390,137.9,389.47a51.63,51.63,0,0,1-4.7-2.91l7.13-11.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.63,293l6.8,4.87,9.73,31.84-16.53,46.68,14.38,4,.93-5.22,2.86-5.48s17.56-38.52,17.8-41.68-7.77-36.46-7.77-36.46l-1.46-14.1-25.29-2.44",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.39,395c.65-.17.81-1.3.81-1.3l-1.43-.84c-6.17-.47-16.52-1.27-17.2-1.27s-10.77-5.9-14.46-8.11l-1.91,3.09a51.63,51.63,0,0,0,4.7,2.91c1.13.49,10.53,5.52,11.67,5.68S166.74,395.15,167.39,395Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79,216.43s-16.16,1.63-16.33,2.29-21.55,23.83-21.55,23.83l5.72,10.94,13.71-5.87-3.92,23.83s-2.61,1,2.12,3.43,15.68,5.55,23.19,5.55,11.75,0,13.39-2.28a8.07,8.07,0,0,0,1.63-4.9c.16-1.31,7.84-21.23,7.84-21.23s17.14,22,17.79,22.54,3.76,1,6.37-2.13,2.12-10.28,2.12-10.28-9.63-17.47-10.12-19.92-2-10-2.94-11.92-2.28-2.12-4.9-3.43-9.79-3.75-9.79-3.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "137.1 223.62 133.34 247.62 134.97 224.92",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.85,
    y1: 246.96,
    x2: 128.61,
    y2: 236.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122.31,
    y1: 240.97,
    x2: 119.79,
    y2: 239.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.34,
    y1: 247.62,
    x2: 124.44,
    y2: 242.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185.23,
    y1: 240.14,
    x2: 189.34,
    y2: 233.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.59,
    y1: 252.02,
    x2: 183.93,
    y2: 242.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.95,
    y1: 244.16,
    x2: 191.79,
    y2: 243.04,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 178.57,
    y1: 251.05,
    x2: 187.72,
    y2: 245.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.75,
    y1: 250.88,
    x2: 193.75,
    y2: 248.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.54,
    y1: 272.11,
    x2: 147.55,
    y2: 268.19,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.46,262.74a24.25,24.25,0,0,0,3-1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.24,268.19A149,149,0,0,0,156,263.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.71,261a11.94,11.94,0,0,1-3.43,7,13,13,0,0,1-7,3.91s1.47,5.56,3.27,5.56,4.9,1,7.67-2.78,3.43-10.12,2.61-11.76S205.51,260.51,203.71,261Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.36,238.8s7.84,14.69,7.18,15-3.42,2.78-4.4,2.94-5.39-4.25-7-8-2.12-5.23-1.63-5.88S115.38,238.8,116.36,238.8Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.43,161.09c.88-5,2.15-17.35-5.38-23.42-9.55-7.7-16.33,6.16-24.65-4.62S432.62,98.85,408,99.15s-26.5,14.18-26.5,18.8-7.39,8-8.93,8-10.17-4-13.25,4.93-1,14.1-5.89,14.29-11-6.49-17.64-3.15-6.67,10.43-9.44,12.89-7.4-1.84-13.56.62c-3.73,1.49-4.86,3.89-5.17,5.55Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.67,64.46c.53-3,1.29-10.49-3.26-14.16-5.77-4.66-9.87,3.72-14.91-2.8S179,26.82,164.07,27s-16,8.57-16,11.37-4.48,4.85-5.41,4.85-6.15-2.43-8,3-.6,8.53-3.56,8.64-6.64-3.92-10.67-1.9-4,6.3-5.71,7.79-4.47-1.12-8.2.38a4.54,4.54,0,0,0-3.13,3.35Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.5,104.46c.32-1.81.78-6.29-2-8.49-3.46-2.8-5.92,2.23-8.94-1.68S109.7,81.89,100.76,82s-9.61,5.14-9.61,6.82-2.68,2.9-3.24,2.9-3.68-1.45-4.8,1.79-.36,5.11-2.14,5.18-4-2.35-6.4-1.14-2.41,3.78-3.42,4.68-2.68-.68-4.91.22a2.71,2.71,0,0,0-1.88,2Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5,278.46c.32-1.81.78-6.29-1.95-8.49-3.46-2.8-5.92,2.23-8.94-1.68s-3.91-12.4-12.85-12.29-9.61,5.14-9.61,6.82-2.68,2.9-3.24,2.9-3.68-1.45-4.8,1.79-.36,5.11-2.14,5.18-4-2.35-6.4-1.14-2.41,3.78-3.42,4.68-2.68-.68-4.91.22a2.71,2.71,0,0,0-1.88,2Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.36,110.61c.28-1.58.68-5.49-1.7-7.41-3-2.44-5.17,2-7.81-1.47S398.44,90.9,390.63,91s-8.39,4.49-8.39,6-2.34,2.54-2.83,2.54-3.22-1.27-4.19,1.56-.32,4.47-1.87,4.53-3.47-2.06-5.58-1-2.11,3.3-3,4.08-2.34-.58-4.3.2a2.35,2.35,0,0,0-1.63,1.75Z",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC22);
export default __webpack_public_path__ + "static/media/c22.aa8be0aa5f9b2989c919a6c8da027dc9.svg";
export { ForwardRef as ReactComponent };